/** Shared dock aside chrome (widths differ per rail). Add `flex` when open. */
export const dockAsideBase =
  "min-h-0 flex-col self-stretch overflow-hidden rounded-lg border border-lab-line bg-lab-panel shadow-[0_8px_24px_rgba(0,0,0,0.3)] max-[720px]:h-[min(50vh,420px)] max-[720px]:w-full max-[720px]:max-w-none max-[720px]:basis-auto";

/** Accent ring while a descendant holds keyboard focus (tracker / instrument / arrange). */
export const dockFocusRing =
  "focus-within:border-[color-mix(in_srgb,var(--accent)_55%,var(--line))] focus-within:shadow-[0_0_0_1px_color-mix(in_srgb,var(--accent)_35%,transparent),0_8px_24px_rgba(0,0,0,0.3)]";

export const synthDockChrome =
  `shrink-0 ${dockFocusRing} max-[720px]:order-[-1] max-[720px]:!w-full`;

/** @deprecated Prefer inline width + synthDockChrome. */
export const synthDockWidth =
  `w-lab-synth max-w-[min(var(--synth-width),42vw)] shrink-0 basis-lab-synth ${dockFocusRing} max-[720px]:order-[-1]`;

export const patternsDockWidth =
  "w-lab-patterns max-w-[min(var(--patterns-width),40vw)] shrink-0 basis-lab-patterns";

/** FX under the tracker — full main-column width; height set inline. */
export const fxBottomPanel =
  "relative min-h-0 w-full shrink-0 flex-col overflow-hidden rounded-md border border-lab-line bg-lab-panel shadow-[0_8px_24px_rgba(0,0,0,0.3)]";

/** Inner panel shell — keep `*-panel` class for plastic transparency. */
export const dockPanel =
  "flex h-full min-h-0 flex-1 flex-col bg-lab-panel text-xs text-slate-300 outline-none";

/** Keep `*-panel-header` / `synth-tabs` / `patterns-panel-tabs` for plastic faceplate. */
export const dockPanelHeader =
  "flex shrink-0 items-center justify-between gap-2 border-b border-lab-line bg-lab-panel-bar px-[0.6rem] py-2";

export const dockPanelTitle = "min-w-0 truncate font-semibold text-slate-100";

export const dockPanelClose =
  "border-transparent bg-transparent px-2 py-0.5 text-xs text-lab-muted hover:bg-white/8";

export const dockPanelScroll = "min-h-0 flex-1 overflow-auto px-[0.55rem] py-[0.45rem]";

export const dockPanelFooter =
  "flex shrink-0 flex-wrap gap-[0.3rem] border-t border-lab-line bg-lab-panel-bar px-[0.55rem] pt-1.5 pb-[0.55rem]";

export const dockPanelFooterBtn = "px-[0.45rem] py-1 text-[11px]";

export const dockFieldControl =
  "box-border w-full rounded border border-lab-line bg-lab-panel-deep px-1.5 py-[0.3rem] text-slate-200 [font:inherit]";

export const dockBodyColumn = "flex min-h-0 flex-1 flex-col overflow-hidden";

export const dockActionsBar =
  "flex shrink-0 flex-wrap gap-[0.35rem] border-b border-white/[0.06] px-[0.55rem] py-1.5";

export const dockActionsBtn = "min-w-[4.5rem] flex-1 px-[0.45rem] py-[0.28rem] text-xs";
